module.exports = __webpack_public_path__ + "static/img/modulo_rele_1_canal_5v-1.9c96549.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/modulo_rele_1_canal_5v-1.svg
// module id = pGeK
// module chunks = 0